import { isEvening, isNight } from './time-tracker';

export function areAttendanceRestrictionsEnabled(): boolean {
  const envValue = import.meta.env.VITE_ENABLE_ATTENDANCE_RESTRICTIONS;
  if (envValue === 'false') return false;
  return true;
}

export function hasLateClockInDeductions(response: {
  success: boolean;
  deductions?: { type: string; amount: number; reason: string }[];
  totalDeductions?: number;
}): boolean {
  return response.success && (!!response.deductions?.length || !!response.totalDeductions);
}

export function checkClockInTimeRestriction(hasClockedInToday: boolean): {
  isAllowed: boolean;
  message?: string;
} {
  if (!areAttendanceRestrictionsEnabled()) {
    return { isAllowed: true };
  }

  const now = new Date();
  const dayOfWeek = now.getDay();

  if (dayOfWeek === 0) {
    return {
      isAllowed: false,
      message: "It's Sunday. Rest well!",
    };
  }

  if (isEvening() || isNight()) {
    return {
      isAllowed: false,
      message: 'You should be resting well!',
    };
  }

  if (hasClockedInToday) {
    return { isAllowed: true };
  }

  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();
  const currentTimeInMinutes = currentHour * 60 + currentMinute;

  const cutoffTime = 18 * 60;
  const resetTime = 7 * 60;

  if (currentTimeInMinutes >= cutoffTime || currentTimeInMinutes < resetTime) {
    return {
      isAllowed: false,
      message: 'Clock-in Disabled Until Tomorrow',
    };
  }

  return { isAllowed: true };
}
